import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class GasFlowMeter extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
        secondaryColor: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e',
        secondaryColor: '#fff'
    };
    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.25).toString()} width={(size / 1.25).toString()} viewBox="0 0 300 251.22">
                <g fill={color}>
                    <rect y={66.18} width={300} height={75.13} rx={2.83} ry={2.83} fill={color} />
                    <circle cx={150} cy={103.75} r={100.62} fill={color} />
                    <path
                        d="M150 207.5a103.75 103.75 0 1 1 103.75-103.75A103.87 103.87 0 0 1 150 207.5zm0-201.23a97.49 97.49 0 1 0 97.49 97.49A97.6 97.6 0 0 0 150 6.27z"
                        fill={secondaryColor}
                    />
                    <path d="M193.33 72.45h-86.66a6.265 6.265 0 0 1 0-12.53h86.65a6.265 6.265 0 1 1 0 12.53z" fill={secondaryColor} />
                    <path
                        d="M265.47 194.68c-1.39-18.09-9.81-29.42-17.24-39.42-6.88-9.26-12.82-17.26-12.82-29.05a2.53 2.53 0 0 0-1.37-2.25 2.5 2.5 0 0 0-2.63.19c-11.16 8-20.47 21.44-23.72 34.28a102.89 102.89 0 0 0-2.55 22.18 2.42 2.42 0 0 1-3.74 2c-7.19-4.52-8.95-16.13-9-16.27a2.53 2.53 0 0 0-3.6-1.92c-.54.26-13.26 6.73-14 32.54-.05.86-.05 1.72-.05 2.58a45.53 45.53 0 0 0 45.48 45.48h.13a45.53 45.53 0 0 0 45.35-45.48c.02-1.33-.24-4.86-.24-4.86zm-60.38 29.07v-1c0-1 .1-1.94.2-2.79a2.4 2.4 0 0 1 4-1.49l.09.09a4.93 4.93 0 0 0 8.21-3.53 40.85 40.85 0 0 1 .93-8.28 22.34 22.34 0 0 1 2.47-6 2.41 2.41 0 0 1 4.22.11 50.35 50.35 0 0 0 3.64 5.71c2.92 4.15 5.95 8.45 6.48 15.78 0 .43.06.87.06 1.34 0 8.9-6.8 16.15-15.16 16.15s-15.14-7.23-15.14-16.09z"
                        fill={color}
                    />
                    <path
                        d="M232.88 123.67a2.54 2.54 0 0 1 2.53 2.53c0 11.8 5.94 19.79 12.82 29.05 7.43 10 15.85 21.34 17.24 39.42 0 0 .26 3.53.26 4.79a45.53 45.53 0 0 1-45.35 45.48h-.13a45.53 45.53 0 0 1-45.48-45.48c0-.86 0-1.72.05-2.58.74-25.81 13.46-32.27 14-32.54a2.46 2.46 0 0 1 1.09-.26 2.58 2.58 0 0 1 1.2.3 2.54 2.54 0 0 1 1.32 1.88c0 .15 1.78 11.76 9 16.27a2.47 2.47 0 0 0 1.32.39 2.4 2.4 0 0 0 2.42-2.35 102.89 102.89 0 0 1 2.55-22.15c3.25-12.84 12.56-26.3 23.72-34.28a2.49 2.49 0 0 1 1.47-.48m-20.25 96.17a4.7 4.7 0 0 1-3.26-1.22l-.09-.09a2.27 2.27 0 0 0-1.58-.63 2.44 2.44 0 0 0-2.42 2.13c-.11.85-.18 1.77-.2 2.78v1c0 8.9 6.8 16.15 15.16 16.15s15.16-7.24 15.16-16.15c0-.47 0-.91-.06-1.34-.53-7.33-3.55-11.62-6.48-15.78a50.33 50.33 0 0 1-3.64-5.71 2.41 2.41 0 0 0-4.22-.11 22.34 22.34 0 0 0-2.47 6 40.88 40.88 0 0 0-.93 8.28 5 5 0 0 1-5 4.81m20.25-102.54a8.7 8.7 0 0 0-5.15 1.67c-12.25 8.77-22.51 23.62-26.11 37.81a85.27 85.27 0 0 0-2.07 12.16 25.87 25.87 0 0 1-.93-3.71 8.82 8.82 0 0 0-4.56-6.46 8.94 8.94 0 0 0-4.15-1 8.78 8.78 0 0 0-3.87.91c-1.66.8-16.62 8.87-17.48 37.88-.05.95-.06 1.9-.06 2.85a51.8 51.8 0 0 0 51.5 51.69h1.12A51.84 51.84 0 0 0 272 199.47c0-1.42-.23-4.62-.28-5.25-1.53-19.91-10.91-32.54-18.45-42.69-6.48-8.72-11.59-15.6-11.59-25.32a8.8 8.8 0 0 0-8.8-8.8zm-20.25 108.7a11.17 11.17 0 0 0 11.24-10.9c0-1.66.14-3.1.3-4.36 2.56 3.65 4.54 6.71 4.92 12v.89c0 5.45-4 9.88-8.9 9.88-4.19 0-7.71-3.23-8.65-7.57h1z"
                        fill={secondaryColor}
                    />
                </g>
            </svg>
        );
    }
}

export default withTheme(GasFlowMeter);



// WEBPACK FOOTER //
// ./data/common/iconsvg/GasFlowMeter.js